import { useRoutes } from 'react-router-dom';
import routes from './router';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import ThemeProvider from './theme/ThemeProvider';
import { CssBaseline } from '@mui/material';
import { useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { setGlobalState, useGlobalState } from './state/globalstate';
import IdleTimer from './session/idle';
// import { version } from 'react';
import Axios, { API, Segment } from './common/api';
import * as crypto from 'crypto';
import React from 'react';
import { Widget, addResponseMessage, toggleMsgLoader } from 'react-chat-widget';
import 'react-chat-widget/lib/styles.css';
import version from '../package.json';
import {
  DeltaIndicator,
  DocumentActions,
  ethnicity_1,
  ethnicity_2,
  Unixdataformatter,
  ActiveIndicator,
  Fullname,
  Religion,
  UpdateOwnerShip
} from './content/dashboard/SearchUserClickHouse/RiderListing/classes';
import './datadog'; // Ensure this file is imported so Datadog initializes
import datadogRum from './datadog';
import StateSelector from './content/authentication/login2/StateSelector';

declare global {
  interface Window {
    analytics: any;
  }
}

const App = () => {
  // // ////console.log(version);
  const isProduction = process.env.NODE_ENV === 'production';
  //console.log('Environment')
  //console.log(isProduction)
  //console.log(version.version)

  const urlPath = window.location.pathname;
  console.log('App Path ==> ', urlPath);

  //Remove console messages
  if (process.env.NODE_ENV === 'production') {
    console.log = () => {};
    console.error = () => {};
    console.debug = () => {};
    console.warn = () => {};
    console.info = () => {};
    console.group = () => {};
    console.groupCollapsed = () => {};
    console.trace = () => {};
  } else if (process.env.NODE_ENV === 'development') {
    console.info = () => {};
    console.group = () => {};
    console.warn = () => {};
    console.groupCollapsed = () => {};
    console.trace = () => {};
  }

  const [keyword, setKeyword] = useState<string>('');
  const value = { keyword, setKeyword };
  const content = useRoutes(routes);
  var CryptoTS = require('crypto-ts');
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    if (Segment.tracking) {
      // window.analytics.page('Page', {
      //   page: 'Login',
      //   name: 'Login'
      // });
      // console.log('Success tracking ===');
    }
  }, []);

  const [modalmessage] = useGlobalState('modalmessage');

  if (modalmessage) {
    modalmessage;
    setGlobalState('modalmessage', null);
  }

  const [loggedin] = useGlobalState('loggedin');

  useEffect(() => {
    // getCountries
    const getCountries = async () => {
      // try {
      //   await Axios.get(API.getCountries2).then((res) => {
      //     // store the data into our books variable
      //     const countriesArray = JSON.parse(res.data[0].country);
      //     console.log('countryArray START ===');
      //     console.log(countriesArray);
      //     setGlobalState('countryListing', countriesArray);
      //     setGlobalState('countriesListing', countriesArray);
      //   });
      // } catch (err) {
      //   console.log(err);
      // }
      
      try {
        await Axios.get(API.RelationAccess).then((res) => {
          // store the data into our books variable

          const RelationAccessArray = res.data;
          console.log(res.data);
          console.log('RelationAccessArray ===');
          console.log(RelationAccessArray);
          setGlobalState('RelationAccessListing', RelationAccessArray);
        });
      } catch (err) {
        console.log(err);
      }

      try {
        await Axios.get(API.getCountries).then((res) => {
          // store the data into our books variable
          const countriesArray = JSON.parse(res.data[0].country);

          setGlobalState('countryListing', countriesArray);
          setGlobalState('countriesListing', countriesArray);

          const countryArray = countriesArray;
          countryArray.push('Palestine');
          countryArray.push('Pakistan');
          countryArray.push('India');
          countryArray.push('Bangladesh');
          countryArray.push('Egypt');
          countryArray.push('');
          countryArray.sort(function (a, b) {
            var nameA = a.toLowerCase(),
              nameB = b.toLowerCase();
            if (nameA < nameB)
              //sort string ascending
              return -1;
            if (nameA > nameB) return 1;
            return 0; //default return value (no sorting)
          });
          setGlobalState('countryListingAll', countryArray);
          const allCountriesArray: string[] = countryArray;
          const updatedSelectedCountries: string = allCountriesArray.join(', ');
          setGlobalState('filtersCountries', updatedSelectedCountries);
          console.log('Shery Called App ===');
        });
      } catch (err) {
        console.log(err);
      }
    };
    if (urlPath != '/candidates' && !urlPath.includes('/contacts')) {
      getCountries();
    }

    // Religion Classifications
    const ReligionClassifications = async () => {
      try {
        await Axios.get(API.ReligionClassifications).then((res) => {
          // store the data into our books variable

          const ReligionArray = res.data;
          console.log(res.data);
          //console.log('countryArray ===')
          //console.log(countryArray)
          setGlobalState('religionListing', ReligionArray);
        });
      } catch (err) {
        console.log(err);
      }
    };
    if (urlPath != '/candidates' && !urlPath.includes('/contacts')) {
      ReligionClassifications();
    }

    //getAugStatus
    const getAugStatus = async () => {
      try {
        await Axios.get(API.getAugStatus).then((res) => {
          // store the data into our books variable

          const AugStatusArray = res.data;
          console.log(res.data);
          //console.log('countryArray ===')
          //console.log(countryArray)
          setGlobalState('AugStatusArray', AugStatusArray);
        });
      } catch (err) {
        console.log(err);
      }
    };
    if (urlPath != '/candidates' && !urlPath.includes('/contacts')) {
      getAugStatus();
    }

    //getBallotStatus
    const getBallotStatus = async () => {
      try {
        await Axios.get(API.getBallotStatus).then((res) => {
          // store the data into our books variable

          const BallotStatusArray = res.data;
          console.log(res.data);
          //console.log('countryArray ===')
          //console.log(countryArray)
          setGlobalState('BallotStatusArray', BallotStatusArray);
        });
      } catch (err) {
        console.log(err);
      }
    };
    if (urlPath != '/candidates' && !urlPath.includes('/contacts')) {
      getBallotStatus();
    }

    // Religion Classifications
    const getOwnership = async () => {
      try {
        await Axios.get(API.getOwnership).then((res) => {
          // store the data into our books variable

          const OwnershipArray = res.data;
          console.log(res.data);
          // console.log('OwnershipArray ===');
          // console.log(OwnershipArray);
          setGlobalState('OwnershipListing', OwnershipArray);
        });
      } catch (err) {
        console.log(err);
      }

      
    };
    if (urlPath != '/candidates' && !urlPath.includes('/contacts')) {
      getOwnership();
    }
    // ColumnDefs
    const getColumnDefs = async () => {
      try {
        let VotersListingColumns = [
          {
            headerName: 'Full Name',
            field: 'full_names',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            width: 300,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Voters Id',
            field: 'statevoterid',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 150,
            hide: true
            // cellRenderer: Fullname,
          },
          {
            headerName: 'City',
            field: 'regcity',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 170,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Nov 2025 Ballot Status',
            field: 'Nov2025_ballot_status',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 170,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Nov 2025 Reason',
            field: 'Reason_for_Nov2025',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 170,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Nov 2025 Received Date',
            field: 'Nov2025_received_date',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 170,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Nov 2025 Challenge Reason',
            field: 'Nov2025_challenge_reason',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 170,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Nov 2025 County',
            field: 'Nov2025_county',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 170,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Nov 2025 City',
            field: 'Nov2025_city',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 170,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Voting Probability',
            field: 'Voting_Probability',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 170,
            hide: true
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Will Voter Vote',
            field: 'Will_voter_vote',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 170,
            hide: false
            // cellRenderer: DeltaIndicator
          },

          {
            headerName: 'Nov 2024 Status',
            field: 'ballot_status',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 150,
            hide: false
            // cellRenderer: UpdateOwnerShip
          },
          {
            headerName: 'Reason for Nov 2024',
            field: 'Reason_for_Nov_2024',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 150,
            hide: false
            // cellRenderer: UpdateOwnerShip
          },
          {
            headerName: 'Nov 2024 Challenge Reason',
            field: 'challenge_reason',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 150,
            hide: false
            // cellRenderer: UpdateOwnerShip
          },
          {
            headerName: 'Nov 2024 Received Date',
            field: 'received_date',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 150,
            hide: false
            // cellRenderer: UpdateOwnerShip
          },

          {
            headerName: 'Aug 2025 Status',
            field: 'PE_2025_ballot_status',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 170,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Aug 2025 Received Date',
            field: 'PE_2025_received_date',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 170,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Aug 2025 Challenge Reason',
            field: 'PE_2025_challenge_reason',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 170,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Reason for Aug 2025',
            field: 'Reason_for_Aug_2025',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 170,
            hide: false
            // cellRenderer: DeltaIndicator
          },

          {
            headerName: 'Religion',
            field: 'llama_names',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 200,
            hide: false
            // cellRenderer: Religion
          },
          {
            headerName: 'Religion Classified By',
            field: 'religion_classified_by',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 200,
            hide: false
            // cellRenderer: Religion
          },
          {
            headerName: 'Ethnicity 1',
            field: 'ethnicity_1',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 200,
            hide: false
            // cellRenderer: ethnicity_1
          },
          {
            headerName: 'Ethnicity 2',
            field: 'ethnicity_2',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 200,
            hide: false
            // cellRenderer: ethnicity_2
          },
          {
            headerName: 'Last Voted',
            field: 'lastvoted',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 200,
            hide: false
            // cellRenderer: DeltaIndicator
          },

          {
            headerName: 'Captain',
            field: 'ownershipName',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 150,
            hide: false
            // cellRenderer: UpdateOwnerShip
          },
          {
            headerName: 'First Name',
            field: 'fname',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 200,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Middle Name',
            field: 'mname',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 200,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Last Name',
            field: 'lname',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 200,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Address',
            field: 'fulladdress',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 220,
            hide: false
            // cellRenderer: DeltaIndicator
          },

          {
            headerName: 'Zip Code',
            field: 'regzipcode',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 150,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Gender',
            field: 'gender',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 150,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Birth Year',
            field: 'birthyear',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 150,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Congressional District',
            field: 'congressionaldistrict',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 150,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Legislative District',
            field: 'legislativedistrict',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 150,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Assembly District',
            field: 'legislative_district_assembly',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 150,
            hide: false
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Senate District',
            field: 'legislative_district_senate',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 150,
            hide: false
            // cellRenderer: DeltaIndicator
          },

          {
            headerName: 'Aug 2024 Status',
            field: 'Aug_2024_Status',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 150,
            hide: true
            // cellRenderer: DeltaIndicator
          },
          {
            headerName: 'Registration Date',
            field: 'registrationdate',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 150,
            hide: false
            // cellRenderer: UpdateOwnerShip
          },
          {
            headerName: 'School District',
            field: 'school_district',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 150,
            hide: false
            // cellRenderer: UpdateOwnerShip
          },
          {
            headerName: 'County',
            field: 'countycode',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            // width:: 150,
            hide: false
            // cellRenderer: UpdateOwnerShip
          },
          {
            headerName: 'Ethnicity Classification',
            field: 'ethnicity_classification',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'AddressNumber Suffix',
            field: 'AddressNumberSuffix',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Assistance Request Flag',
            field: 'AssistanceRequestFlag',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Email',
            field: 'Email',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Ems Voter Id',
            field: 'EmsVoterId',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Extract Date',
            field: 'ExtractDate',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Language',
            field: 'Language',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Name Prefix',
            field: 'NamePrefix',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'NonStandard Address',
            field: 'NonStandardAddress',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Oct 2024 Status',
            field: 'Oct_2024_Status',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Phone 1 Area',
            field: 'Phone1Area',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Phone 1 Exchange',
            field: 'Phone1Exchange',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Phone 1 NumberPart',
            field: 'Phone1NumberPart',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Phone 2 Area',
            field: 'Phone2Area',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Phone 2 Exchange',
            field: 'Phone2Exchange',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Phone 2 Number Part',
            field: 'Phone2NumberPart',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Phone 3 Area',
            field: 'Phone3Area',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Phone 3 Exchange',
            field: 'Phone3Exchange',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Phone 3 Number Part',
            field: 'Phone3NumberPart',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Phone 4 Area',
            field: 'Phone4Area',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Phone 4 Exchange',
            field: 'Phone4Exchange',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Phone 4 NumberPart',
            field: 'Phone4NumberPart',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Place Of Birth',
            field: 'PlaceOfBirth',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Precinct',
            field: 'Precinct',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Registration Method Code',
            field: 'RegistrationMethodCode',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Vbm Voter Type',
            field: 'VbmVoterType',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Voter Status Reason Code Desc',
            field: 'VoterStatusReasonCodeDesc',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Mail 1',
            field: 'mail1',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Mail 2',
            field: 'mail2',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Mail 3',
            field: 'mail3',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Mail City',
            field: 'mailcity',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Mail Country',
            field: 'mailcountry',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Mail State',
            field: 'mailstate',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Mail Zip',
            field: 'mailzip',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Name Suffix',
            field: 'namesuffix',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Party',
            field: 'party',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Party 2',
            field: 'party2',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Regst Frac',
            field: 'regstfrac',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Regst Predirection',
            field: 'regstpredirection',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          },
          {
            headerName: 'Regst Unit Num',
            field: 'regstunitnum',
            sortable: true,
            filter: 'agTextColumnFilter',
            floatingFilter: true,
            hide: true
          }
        ];

        const getColumns = localStorage.getItem('VoterListingColumnDefs');
        console.log('VotersListingColumns 555 ===');
        console.log(VotersListingColumns);
        console.log(getColumns)
        if (!getColumns || getColumns == '[]') {
          let VotersListingColumnsString = JSON.stringify(VotersListingColumns);
          localStorage.setItem(
            'VoterListingColumnDefs',
            VotersListingColumnsString
          );
        }
      } catch (err) {
        console.log(err);
      }
    };


    if (urlPath != '/candidates' && !urlPath.includes('/contacts')) {
      getColumnDefs();
    }
  }, []);

  // useEffect(() => {
  //   addResponseMessage('Welcome to this AMAC Voters Q chat!');
  // }, []);

  // const handleNewUserMessage = async (newMessage) => {
  //   let chatResponse = '';
  //   toggleMsgLoader();
  //   ////console.log(`New message incoming! ${newMessage}`);
  //   const params = { question: encodeURIComponent(newMessage) };
  //   try {
  //     await Axios.get(API.mlrcBedrock, {
  //       params
  //     }).then((res) => {
  //       // store the data into our books variable
  //       ////console.log(res.data.response);
  //       chatResponse = res.data.response;
  //       // let chatResponse = res.data;
  //     });
  //   } catch (err) {
  //     // setGlobalState('ErrorFoundGlobal', false);
  //     // ////console.log(err);
  //   }

  //   addResponseMessage(chatResponse);
  //   toggleMsgLoader();
  //   // Now send the message throught the backend API
  // };

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        {content}
        <div>
          {/* Floating Button */}
          {/* <StateSelector /> */}
        </div>
        <IdleTimer />
        <ToastContainer
          position="bottom-right"
          autoClose={6000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          className="toast-mobile-offset"
        />
        {/* <div className="App">
          <Widget
            handleNewUserMessage={handleNewUserMessage}
            // profileAvatar={logo}
            title="AMAC Voters Q"
            // subtitle="And my cool subtitle"
          />
        </div> */}
      </LocalizationProvider>
    </ThemeProvider>
  );
};
export default App;
